import { useDispatch, useSelector } from "react-redux";
import { useFinancialReportService } from "serviceHooks";
import { AppState } from "store";
import { setCompanyLastReconciliation } from "store/actions/commonActions";

function useLastReconciliation() {
  const dispatch = useDispatch();
  const { getLastReconciliationIdForFinancialYear } = useFinancialReportService();

  const lastReconciliation = useSelector((state: AppState) => state.common.companyLastReconciliation);

  const annualAccountsFinancialYear = useSelector(
    (store: AppState) => store.auth.selectedCompany.annualAccountsFinancialYear
  );

  const getLastReconciliation = async () => {
    if (lastReconciliation !== undefined) {
      return lastReconciliation;
    }

    const results = await getLastReconciliationIdForFinancialYear(annualAccountsFinancialYear!.id);
    dispatch(setCompanyLastReconciliation(results));

    return results;
  };

  return { getLastReconciliation, lastReconciliation };
}

export default useLastReconciliation;
